import React from "react";
import withShipment from "../../../withShipment";

import SearchableTable from "../../global/Search/SearchableTable";
import SaveIcon from "@material-ui/icons/Save";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import {ENABLE_MATCH_RULE, MANAGE_RULE, RULE_DESCRIPTION, SAVE} from "./constants";
import {userInfoSelector} from "../../../redux/selectors/auth";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {Tooltip} from "@mui/material";
import InfoIcon from "@material-ui/icons/Info";
import {TextField} from "@material-ui/core";
import {listRules, saveRules} from "../../../redux/actions/settings";
import {clearStatus} from "../../../redux/actions/global";
import {rulesSelector} from "../../../redux/selectors/settings";
import "./ManageRule.css"



class ManageRule extends SearchableTable {
    constructor(props) {
        super(props);
        this.state = {
            machines: this.props.machines || [],
            feedbackBarOpen: false,
            feedbackStatus: '',
            feedbackMessage: '',
            enableMatchRule: false,
            ruleName: "",
            timeLimit: "",
            maxMatchesPerDay: '',
            maxCountResetTime: '',
            maxCountReset: ''
        }


    }

    componentDidMount() {
       this.props.listRules({locationId: this.props.userInfo.selectedLocationId})


    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.rules !== this.props.rules) {

            if (Array.isArray(this.props.rules) && this.props.rules.length > 0) {

                this.setState({
                    ruleName: this.props.rules[0].ruleName,
                    timeLimit: this.props.rules[0].timeLimit,
                    enableMatchRule: this.props.rules[0].enableMatchRule,
                    maxMatchesPerDay: this.props.rules[0].maxMatchesPerDay,
                    resetTimes: this.props.rules[0].resetTimes,
                    maxCountResetTime: this.props.rules[0].maxCountResetTime,
                });
            }


        }

    }


    getContextualMenuItems = () => [
        {
            title: SAVE,
            icon: <SaveIcon />,
            onClick: this.handleSave,
            disabled: this.isSaveDisabled(),
        }
    ];

    handleSave = () => {

        const callback = (error, response) => {
            if (error) {
                this.openFeedbackBar('error',error)
            } else {
                this.openFeedbackBar('success',response)
            }
        };


        this.props.saveRules({
            ruleName: this.state.ruleName,
            locationId: this.props.userInfo.selectedLocationId,
            enableMatchRule : this.state.enableMatchRule,
            timeLimit : this.state.timeLimit,
            resetTimes: this.state.resetTimes,
            maxMatchesPerDay: this.state.maxMatchesPerDay,
            maxCountResetTime: this.state.maxCountResetTime,
        }, callback);
    };

    isSaveDisabled = () => {
        return this.state.machines.some(template => !template.machine);
    };

    openFeedbackBar = (status,message) => {
        this.setState({feedbackStatus: status, feedbackMessage: message,feedbackBarOpen: true})
    }

    closeFeedbackBar = () => {
        this.setState({ feedbackBarOpen: false, feedbackStatus: '', feedbackMessage:''}, () => {
            this.props.clearStatus()
        })
    }


    handleChange = (e) => {
        const { name, value } = e.target;

        this.setState({ [name]: value });
    }

    render() {

        return (
          <React.Fragment>
              <TopToolbar
                pageName={MANAGE_RULE}
                menuItems={this.getContextualMenuItems()}
              />

              <FeedbackBar
                open={this.state.feedbackBarOpen}
                handleClose={this.closeFeedbackBar}
                severity={this.state.feedbackStatus}
                message={this.state.feedbackMessage}
              />



                  <div className="manage-rule-container">
                      <div className="manage-rule-form-section">


                          <div className="form-footer">
                              <FormControlLabel
                                className="match-rule-checkbox"
                                control={
                                    <Checkbox
                                      checked={this.state.enableMatchRule}
                                      onChange={(e) =>
                                        this.setState({ enableMatchRule: e.target.checked })
                                      }
                                    />
                                }
                                label={ENABLE_MATCH_RULE}
                              />

                              <Tooltip title={RULE_DESCRIPTION}>
                                  <InfoIcon className="info-icon" />
                              </Tooltip>
                          </div>

                          <div className="form-fields">
                              <TextField
                                className="input-manage-text-field"
                                name="ruleName"
                                label="Rule Name"
                                value={this.state.ruleName}
                                onChange={this.handleChange}
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                              />
                              <TextField
                                className="input-manage-text-field"
                                label="Cooldown (hours)"
                                name="timeLimit"
                                value={this.state.timeLimit}
                                InputLabelProps={{ shrink: true }}
                                onChange={this.handleChange}
                                variant="outlined"
                                type="number"
                              />

                              <TextField
                                className="input-manage-text-field"
                                label="Max Matches per Day"
                                name="maxMatchesPerDay"
                                InputLabelProps={{ shrink: true }}
                                value={this.state.maxMatchesPerDay}
                                onChange={this.handleChange}
                                type="number"
                                variant="outlined"
                              />
                              <TextField
                                className="input-manage-text-field"
                                label="Reset Times (comma-separated, e.g. 05:00,17:00)"
                                name="resetTimes"
                                value={this.state.resetTimes}
                                InputLabelProps={{ shrink: true }}
                                onChange={this.handleChange}
                                variant="outlined"
                              />

                              <TextField
                                className="input-manage-text-field"
                                label="Reset Day Time (e.g. 05:00)"
                                name="maxCountResetTime"
                                value={this.state.maxCountResetTime}
                                InputLabelProps={{ shrink: true }}
                                onChange={this.handleChange}
                                variant="outlined"
                              />


                          </div>


                      </div>
                  </div>


          </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    userInfo: userInfoSelector(state),
    rules: rulesSelector(state),
})

const actionCreators = {
    listRules,
    saveRules,
    clearStatus,
}
export default withShipment({
    mapStateToProps,
    actionCreators
}, ManageRule);